exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.commit[data-v-17487cb2] {\n  min-height: 4.75rem;\n}\n", ""]);

